const {Component} = require("react");
const PropTypes = require("prop-types");
const router = require("app/services/router");
const AnchorLink = require("app/components/mixins/Link");

class Link extends Component {
	static get propTypes() {
		return {
			label: PropTypes.string.isRequired,
			target: PropTypes.any.isRequired,
			type: PropTypes.string,
			active: PropTypes.bool,
			disabled: PropTypes.bool,
			onActivate: PropTypes.func
		};
	}

	static get defaultProps() {
		return {
			active: false,
			disabled: false,
			type: null
		}
	}

	_onClick = () => {
		//e.preventDefault();

		if (this.props.active || this.props.disabled) {
			return;
		}

		if (typeof this.props.onActivate === "function") {
			this.props.onActivate(this.props.target);
		}
	};

	get className() {
		let classList = [];

		if (this.props.type) {
			classList.push(this.props.type);
		}

		if (this.props.active) {
			classList.push("active");
		}

		if (this.props.disabled) {
			classList.push("disabled");
		}

		return classList.join(" ");
	}

	get url() {
		return router.url(router.currentPath, {
			page: this.props.target
		});
	}

	render() {
		return (
			<li className={this.className}>
				<AnchorLink href={this.url} onClick={this._onClick}>
					<span>{this.props.label}</span>
				</AnchorLink>
			</li>
		);
	}
}

class Separator extends Component {
	render() {
		return (
			<li className="separator">
				<span>...</span>
			</li>
		);
	}
}

class Paginator extends Component {

	static get propTypes() {
		return {
			page: PropTypes.number,
			pages: PropTypes.number.isRequired,
			wrap: PropTypes.number,
			onChange: PropTypes.func
		};
	}

	static get defaultProps() {
		return {
			page: 1,
			wrap: 2
		};
	}

	constructor(props) {
		super(props);

		this.state = {
			page: props.page,
			pages: props.pages
		};
	}

	componentWillReceiveProps(nextProps) {
		let state = {};

		if (nextProps.page && (this.state.page !== nextProps.page)) {
			state.page = nextProps.page;
		}

		if (nextProps.pages && (this.state.pages !== nextProps.pages)) {
			state.pages = nextProps.pages;
		}

		if (Object.keys(state).length > 0) {
			this.setState(state);
		}
	}

	get currentPage() {
		return this.state.page;
	}

	get className() {
		let classList = ["paginator"];

		if (this.state.pages <= 1) {
			classList.push("hidden");
		}

		return classList.join(" ");
	}

	_onChange = (page) => {
		let newPage;

		if (page === "prev") {
			newPage = this.currentPage - 1;

			if (newPage < 1) {
				newPage = 1;
			}
		}
		else if (page === "next") {
			newPage = this.currentPage + 1;

			if (newPage > this.state.pages) {
				newPage = this.state.pages;
			}
		}
		else {
			newPage = page;
		}

		if (newPage !== this.currentPage) {
			this.setState({page: newPage});

			if (typeof this.props.onChange === "function") {
				this.props.onChange(newPage);
			}
		}
	};

	pageLinks() {
		const start = {
			from: 1,
			to: Math.min(this.props.wrap, this.state.pages)
		};

		const active = {
			from: Math.min(Math.max(start.to + 1, this.currentPage - this.props.wrap), this.state.pages),
			to: Math.min(this.currentPage + this.props.wrap, this.state.pages)
		};

		const end = {
			from: Math.min(Math.max(active.to + 1, this.state.pages - this.props.wrap - 1), this.state.pages),
			to: this.state.pages
		};

		let links = [];

		[start, active, end].forEach(interval => {
			if (links[links.length - 1] >= interval.from) {
				return;
			}

			for (let i = interval.from; i <= interval.to; i++) {
				links.push(i);
			}
		});

		return links;
	}

	renderLinks() {
		let links = [];

		// Prev link
		links.push(
			<Link key="prev" type="prev" target="prev" label="<<" disabled={this.currentPage === 1}
						onActivate={this._onChange}/>
		);

		// Pages
		let pageLinks = this.pageLinks();

		pageLinks.forEach((target, i) => {
			// Add separator to non-consecutive pages
			if ((i > 0) && (pageLinks[i - 1] !== target - 1)) {
				for (let j = pageLinks[i - 1] + 1; j < target; j++) {
					links.push(
						<Link key={j} type="sr-only" target={j} label={j.toString()} active={false} onActivate={this._onChange}/>
					);
				}

				links.push(<Separator key={`separator_${i}`}/>);
			}

			links.push(<Link key={target} type="page" target={target} label={target.toString()}
											 active={target === this.currentPage}
											 onActivate={this._onChange}/>)
		});

		// Next link
		links.push(
			<Link key="next" type="next" target="next" label=">>" disabled={this.currentPage === this.state.pages}
						onActivate={this._onChange}/>
		);

		return links;
	}

	render() {
		return (
			<ul className={this.className}>{this.renderLinks()}</ul>
		);
	}

}

module.exports = Paginator;
